var map = {
	"./bo.json": "0cce",
	"./de.json": "e45a",
	"./en.json": "07a7",
	"./es.json": "a16d",
	"./fi.json": "e13c",
	"./fr.json": "834a",
	"./it.json": "20cd",
	"./nb_NO.json": "245a",
	"./pt_BR.json": "caa2",
	"./ro.json": "8a34",
	"./si.json": "972e",
	"./ug.json": "cfe1",
	"./zh_Hans.json": "338f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebab";